window.addEventListener('DOMContentLoaded', function () {
  const main = document.querySelector('main')
  if (!main || !main.classList.contains('about')) return

  const subTabGroup = main.querySelector('.js_sub_tab')
  if (!subTabGroup) return

  const subTabButtons = subTabGroup.querySelectorAll('.js_sub_tab_btn')
  const subTabContents = subTabGroup.querySelectorAll('.js_sub_tab_content')
  const exTabButtons = subTabGroup.querySelectorAll('.js_ex_tab_btn')
  const backTabButtons = subTabGroup.querySelectorAll('.js_back_tab_btn')
  const subTabContentsWrap = subTabGroup.querySelector('.js_tab_contents')

  if (!subTabContents.length) return

  function activateAboutSubTab(tabName) {
    subTabButtons.forEach((button) => {
      button.classList.toggle('is-current', button.dataset.tab === tabName)
    })

    subTabContents.forEach((content) => {
      content.classList.toggle('is-current', content.dataset.tabContent === tabName)
    })
  }

  function getHeaderHeight() {
    const header = document.querySelector('header') || document.querySelector('.header')
    return header ? header.offsetHeight : 0
  }

  function scrollSubTabContentsToTop() {
    if (!subTabContentsWrap) return

    const headerHeight = getHeaderHeight()
    const top = subTabContentsWrap.getBoundingClientRect().top + window.pageYOffset - headerHeight

    window.scrollTo({
      top: top,
      behavior: 'smooth',
    })
  }

  exTabButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault()

      const targetTab = this.dataset.tabContent
      if (!targetTab) return

      activateAboutSubTab(targetTab)
      scrollSubTabContentsToTop()
    })
  })

  backTabButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault()
      activateAboutSubTab('activity04')
      scrollSubTabContentsToTop()
    })
  })
})
